import { RootState } from "store/reducers/main";
import { FeatureFlagsEnum } from "types/working-model";

export const selectFeatureFlag = (flag: FeatureFlagsEnum) =>
	(state: RootState) => state.FeatureFlagsReducer.featureFlags[flag];

export const selectUseConfirmationUrls = selectFeatureFlag(FeatureFlagsEnum.integrations_confirmation_urls);

export const selectUseSsoAttrMapping = selectFeatureFlag(FeatureFlagsEnum.sso_attr_mapping_2025);
export const selectEditorNavV3 = selectFeatureFlag(FeatureFlagsEnum.editor_nav_v3);
export const selectUiAiCaptions = selectFeatureFlag(FeatureFlagsEnum.ui_ai_captions);
